import { Businesses } from '@just-in-types';
import { Link } from '@reach/router';
import * as React from 'react';
import styled from 'react-emotion';
import Container from '../components/Container';
import ErrorBoundary from '../hoc/withErrorBoundary';

interface IHomeOwnProps {
  default?: boolean;
  path?: string;
  routes: Array<Businesses.Business | Businesses.Site>;
}

type HomeProps = IHomeOwnProps;

const HomeContainer = styled(Container)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  overflow-y: scroll;
`;
const HomeLink = styled(Link)`
  display: block;
  font-size: 3rem;
  margin: 1rem auto;
  @media screen and (max-width: 800px) {
    font-size: 5.5vw;
  }
`;

class Home extends React.Component<HomeProps> {
  public render() {
    const { routes } = this.props;

    return (
      <ErrorBoundary>
        <HomeContainer>
          {routes
            .sort(({ path: pathA }, { path: pathB }) =>
              pathA === pathB ? 0 : pathA > pathB ? 1 : -1,
            )
            .map((route, index) => (
              <HomeLink key={index} to={route.path}>
                {route.path}
              </HomeLink>
            ))}
        </HomeContainer>
      </ErrorBoundary>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.tsx